import { Envelope, Phone, MapPin, GlobeSimple, LinkedinLogo, GithubLogo } from "@phosphor-icons/react";

// Returns an ordered list of visible contact/link items with their icons.
// Templates iterate this instead of hand-referencing each field so we only
// have to maintain the icon/order mapping in one place.
export function contactItems(personal, { includeLinks = true, includeContact = true } = {}) {
  const items = [];
  if (includeContact) {
    if (personal.email) items.push({ key: "email", Icon: Envelope, value: personal.email });
    if (personal.phone) items.push({ key: "phone", Icon: Phone, value: personal.phone });
    if (personal.location) items.push({ key: "location", Icon: MapPin, value: personal.location });
  }
  if (includeLinks) {
    if (personal.website) items.push({ key: "website", Icon: GlobeSimple, value: personal.website });
    if (personal.linkedin) items.push({ key: "linkedin", Icon: LinkedinLogo, value: personal.linkedin });
    if (personal.github) items.push({ key: "github", Icon: GithubLogo, value: personal.github });
  }
  return items;
}

// Renders a single "[icon] value" chip. Templates pass their own colour /
// font-size so the icon matches the surrounding typography. Icons render as
// inline SVG so they print correctly with window.print().
export function ContactBit({ Icon, value, size = 10, color = "currentColor", style = {} }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4, whiteSpace: "nowrap", ...style }}>
      <Icon size={size} weight="regular" color={color} style={{ flexShrink: 0 }} />
      <span style={{ overflowWrap: "anywhere" }}>{value}</span>
    </span>
  );
}

// Convenience: an inline row of ContactBit chips joined by a chosen separator.
export function ContactRow({ personal, separator = " · ", size = 10, color = "currentColor", style = {}, ...opts }) {
  const items = contactItems(personal, opts);
  if (!items.length) return null;
  return (
    <div data-resume-contact="true" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 4, ...style }}>
      {items.map((it, i) => (
        <span key={it.key} style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          <ContactBit Icon={it.Icon} value={it.value} size={size} color={color} />
          {i < items.length - 1 && <span style={{ color, opacity: 0.5 }}>{separator}</span>}
        </span>
      ))}
    </div>
  );
}
